import {QueryClient} from "@tanstack/react-query";

// Server state lives in TanStack Query; Redux keeps UI state only.
//
// Defaults are deliberately conservative so behaviour matches the previous
// hand-rolled hooks:
// - retry: false        – Requester.js already retries transient 5xx once.
// - refetchOnWindowFocus – off; live updates arrive over the websocket, which
//                          invalidates the affected queries.
// - staleTime 30s       – several components may ask for the same data
//                          (contract, integrations, ...) during one render pass;
//                          they share one request instead of each firing their own.
export const QUERY_DEFAULTS = {
    queries: {
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 30 * 1000,
    },
    mutations: {
        retry: false,
    },
};

export function createQueryClient(overrides = {}) {
    return new QueryClient({
        defaultOptions: {
            queries: {...QUERY_DEFAULTS.queries, ...overrides.queries},
            mutations: {...QUERY_DEFAULTS.mutations, ...overrides.mutations},
        },
    });
}

export const queryClient = createQueryClient();
